import { Component, Input, inject } from '@angular/core';
import { ContentUtil } from '../../../../utils/content/content.util';
import { LoggerService } from '../../../../services/logger/logger.service';
import { Observable, take } from 'rxjs';
import { AccessTypeSelection } from '../../../../../common/enums/access-type-selection.enum';
import { Store } from '@ngrx/store';
import { selectAddUserStepperSelectedAccess } from '../../../../store/selectors/grant-revoke-permissions.selector';
import { configData } from './gaf-mvp-pin-adobe';
import { AdobeTagging } from '../../../../utils/decorators/dev/adobe-launch';
import { ButtonModule } from '@vg-constellation/angular-20/button';

@AdobeTagging(configData)
@Component({
    selector: 'zci-gaf-mvp-pin-component',
    templateUrl: 'gaf-mvp-pin-component.html',
    imports: [
        ButtonModule,
    ],
})
export class GafMvpPinComponent {
    private store = inject(Store);
    private readonly loggerService = inject(LoggerService);

    readonly accessTypeSelection = AccessTypeSelection;

    @Input() uniquePin: string;

    selectedAccess$: Observable<AccessTypeSelection> = this.store.select(
        selectAddUserStepperSelectedAccess,
    );


    content = ContentUtil.grantorFragmentContent.add_user.frmcAddUserReviewSubmit.lstNewGranteeNotOnListSuccessMessage.listiWhatsNextUniquePin;

    async copyPinToClipboard() {
        try {
            await navigator.clipboard.writeText(this.uniquePin);

            this.selectedAccess$.pipe(take(1)).subscribe((accessType) => {
                if (accessType === this.accessTypeSelection.INFORMATION_ONLY) {
                    this.adobeCopyPinInfoOnly();
                } else if (accessType === this.accessTypeSelection.LIMITED_ACCESS) {
                    this.adobeCopyPinLimited();
                }
            });
        } catch (err) {
            this.loggerService.warn('Could not copy to clipboard');
        }
    }

    private adobeCopyPinInfoOnly(): void { }
    private adobeCopyPinLimited(): void { }
}
